import React, { useRef, useEffect, useCallback } from 'react';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import './dateRangePickerExtended.css';

export default function DateRangePickerExtended({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  onClose,
}) {
  const pickerRef = useRef(null);

  const handleClickOutside = useCallback(
    event => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        onClose();
      }
    },
    [onClose]
  );

  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: 'selection',
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);

  const handleSelect = ranges => {
    if (ranges['selection']) {
      setStartDate(ranges['selection'].startDate);
      setEndDate(ranges['selection'].endDate);
    }
    if (
      ranges['selection'].startDate &&
      ranges['selection'].endDate &&
      ranges['selection'].startDate !== ranges['selection'].endDate
    ) {
      onClose();
    }
  };

  return (
    <div className="overlay">
      <div ref={pickerRef}>
        <DateRangePicker
          ranges={[selectionRange]}
          onChange={handleSelect}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          months={2}
          direction="horizontal"
          staticRanges={[]}
          inputRanges={[]}
        />
      </div>
    </div>
  );
}
